module.exports = __webpack_public_path__ + "img/check_foot_step.69d319ae.png";